import { Routes, Route, Link, useNavigate, useLocation } from "react-router-dom";

import { Space, Breadcrumb, Menu, Card, Button, message } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import { useTitle } from "../helpers";
import {
   Site
} from "../../model/model";

import SessionStore from "../../model/SessionStore";
import DeleteConfirm from "../../components/DeleteConfirm";
import EditSite from "./EditSite";

import SiteDashboard from "./SiteDashboard";
function SiteLayout({ site }: { site: Site }) {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  useTitle("Sites", site.name);
  const location = useLocation();

  const deleteSite = () => {
    SessionStore.getClient().removeSite(site.id, SessionStore.getBearer()).then(() => {
      navigate("/sites");
    }).catch(err=>{
      console.log("ERR",err);
        if(err.status == 401){
          navigate(`/login`);
        }else{
          messageApi.open({
            type: 'error',
            content: err.message,
          });
        }
    });
  };

  let tab = "dash";
  if (location.pathname.endsWith("/edit")) {
    tab = "edit";
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>{site.name}</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title={site.name}
        subTitle={`site id: ${site.id}`}
        extra={[
            <DeleteConfirm confirm={site.name} typ="site" onConfirm={deleteSite}>
              <Button danger type="primary">
                Delete site
              </Button>
            </DeleteConfirm>
        ]}
      />

      <Card>
        <Menu mode="horizontal" selectedKeys={[tab]} style={{ marginBottom: 24 }}>
          <Menu.Item key="dash">
            <Link to={`/site/${site.id}/dash`}>Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="edit">
            <Link to={`/site/${site.id}/edit`}>Configuration</Link>
          </Menu.Item>        </Menu>
        <Routes>
          <Route path="/" element={<SiteDashboard site={site}/>} />
          <Route path="/dash" element={<SiteDashboard site={site}/>} />
          <Route path="/edit" element={<EditSite site={site} />} />
        </Routes>
      </Card>
    </Space>
  );
}

export default SiteLayout;
